import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import {
  I18nService,
  TranslationsProvider,
  I18N_CONFIG_TOKEN,
  LOCALE,
  LANGUAGE_CONFIG,
  PhraseAppTranslationService,
  PhraseAppEditorService,
  PHRASE_APP_TRANSLATIONS,
} from '@core/i18n-legacy';
import {
  IconsContainerBundledStrategy,
  provideIconsContainerStrategy,
} from '@core/user-interface-legacy';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withHashLocation()),
    provideIconsContainerStrategy({ useClass: IconsContainerBundledStrategy }),
    { provide: I18N_CONFIG_TOKEN, useValue: { phraseAppProjectId: '', editorEnabled: false } },
    { provide: LOCALE, useValue: 'en' },
    { provide: LANGUAGE_CONFIG, useValue: { defaultLanguage: 'en', languages: ['en'] } },
    { provide: PHRASE_APP_TRANSLATIONS, useValue: [{ en: {} }] },
    PhraseAppEditorService,
    PhraseAppTranslationService,
    { provide: TranslationsProvider, useExisting: PhraseAppTranslationService },
    I18nService,
  ],
};
